import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import Navigation from './components/navigation/Navigation'

import store from './store/Store'
import views from './views/Views'
import routes from './routes/Routes'

import './index.scss'

import * as serviceWorker from './serviceWorker/serviceWorker'

const context = require('./context/Context')

// console.log(context);

ReactDOM.render(
  <Provider /*context={context}*/ store={store}>
    <Router>
      <Navigation
        history={ this }
        article={ store.getState().article }
        navigation={ store.getState().navigation }
      />

      <Switch>
        <Route exact path={ routes.ROUTE_LOGIN } component={ views.LoginView } />
        <Route exact path={ routes.ROUTE_REGISTER } component={ views.RegisterView } />
        <Route exact path={ routes.ROUTE_ARTICLE } component={ views.EditorTemplateView } />
        <Route exact path={ routes.ROUTE_OVERVIEW } component={ views.EditorOverviewView } />
        <Route exact path={ routes.ROUTE_USER } component={ views.EditorUserView } />

        <Route path={ '*' }>
          <Redirect to={ routes.ROUTE_LOGIN } />
        </Route>
      </Switch>
    </Router>
  </Provider>, 
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
